import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const RemoveIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10.5" stroke="currentColor" />
    <path
      d="M5 12.25C5 11.836 5.34844 11.5 5.77778 11.5H18.2222C18.6516 11.5 19 11.836 19 12.25C19 12.664 18.6516 13 18.2222 13H5.77778C5.34844 13 5 12.664 5 12.25Z"
      fill="currentColor"
    />
  </svg>
);

export { RemoveIcon };
